module.exports = __webpack_public_path__ + "static/media/Saveblue.b8032f0a.svg";